import { Container, Graphics } from "pixi.js";
import { WALL, indoor } from "./common.js";

/**
 * El local del patio: cafetería.
 *
 * El mostrador NO se dibuja acá. Es un elemento del catálogo, y el motor ya le pinta
 * su silueta con el mismo contorno que usa para el clic — dibujarlo también aquí
 * dejaría dos mostradores desalineados en cuanto alguien moviera uno con F2.
 */
export function sweet(): Container {
  const scene = indoor({ wall: 0x6b4226, floor: 0xd9c4a3, skirting: 0x4d2f1b });

  // Pizarra del menú, detrás de la caja.
  const menu = new Graphics();
  menu.rect(300, 60, 360, 140).fill(0x2f2117).stroke({ width: 8, color: 0xc99a5b });
  for (let i = 0; i < 5; i++) {
    menu.rect(330, 86 + i * 22, 180 + (i % 3) * 60, 8).fill({ color: 0xe8dcc8, alpha: 0.7 });
  }
  scene.addChild(menu);

  // Cafetera a un lado, vitrina de dulces al otro.
  const gear = new Graphics();
  gear.rect(120, 120, 120, 80).fill(0xb9c0c6).stroke({ width: 3, color: 0x8d959b });
  gear.rect(140, 140, 32, 40).fill(0x4a4f54);
  gear.rect(196, 140, 32, 40).fill(0x4a4f54);
  gear
    .rect(720, 120, 140, 80)
    .fill({ color: 0xf2e8d8, alpha: 0.9 })
    .stroke({ width: 3, color: 0xc99a5b });
  gear.rect(736, 150, 108, 10).fill(0xd98ca0);
  gear.rect(736, 172, 108, 10).fill(0xc98b52);
  scene.addChild(gear);

  // Alfombra bajo las mesas: da calidez y marca la zona de estar.
  const rug = new Graphics();
  rug.ellipse(480, 430, 300, 80).fill({ color: 0xb8895c, alpha: 0.35 });
  scene.addChild(rug);

  const trim = new Graphics();
  trim.rect(0, WALL - 12, 960, 12).fill(0x4d2f1b);
  scene.addChild(trim);

  return scene;
}
